import { GreyBoxLoader } from '@xarvio/elements';
import {
  Column,
  ColumnCell,
  PageLayoutColumns,
  Panel,
  Panels,
} from '@xarvio/layout';

import styles from './TableStatusPageLoading.module.scss';

const TABLE_COLUMN_COUNT = 8;
const TABLE_ROW_COUNT = 12;

export const TableStatusPageGrowthStageCellLoading = () => {
  return (
    <div className={styles.growthStage}>
      <GreyBoxLoader className={styles.growthStageLine} />
      <GreyBoxLoader className={styles.growthStageLine} />
    </div>
  );
};

export const TableStatusPageLastTreatmentCellLoading = () => {
  return (
    <div className={styles.lastTreatment}>
      <GreyBoxLoader className={styles.lastTreatmentLine} />
      <GreyBoxLoader className={styles.lastTreatmentLine} />
    </div>
  );
};

export const TableStatusPageDataCellLoading = () => (
  <GreyBoxLoader className={styles.tableCell} />
);

export const TableStatusPageDataHeaderLoading = () => (
  <GreyBoxLoader className={styles.tableHeader} />
);

export const TableStatusPageDataLoading = () => {
  return (
    <div className={styles.table}>
      <div className={styles.headerRow}>
        <div className={styles.fieldCell}>
          <GreyBoxLoader className={styles.checkbox} />
          <GreyBoxLoader className={styles.fieldHeader} />
        </div>
        <div className={styles.cell}>
          <GreyBoxLoader className={styles.growthStageHeader} />
        </div>
        <div className={styles.cell}>
          <GreyBoxLoader className={styles.lastTreatmentHeader} />
        </div>
        {Array.from({ length: TABLE_COLUMN_COUNT - 3 }, (_, index) => (
          <div className={styles.cell} key={index}>
            <TableStatusPageDataHeaderLoading />
          </div>
        ))}
      </div>

      {Array.from({ length: TABLE_ROW_COUNT }, (_, index) => (
        <div className={styles.row} key={index}>
          <div className={styles.fieldCell}>
            <GreyBoxLoader className={styles.checkbox} />
            <div className={styles.fieldDetails}>
              <GreyBoxLoader className={styles.fieldName} />
              <GreyBoxLoader className={styles.fieldCrop} />
              <GreyBoxLoader className={styles.fieldArea} />
            </div>
          </div>
          <div className={styles.cell}>
            <TableStatusPageGrowthStageCellLoading />
          </div>
          <div className={styles.cell}>
            <TableStatusPageLastTreatmentCellLoading />
          </div>
          {Array.from({ length: TABLE_COLUMN_COUNT - 3 }, (_, columnIndex) => (
            <div className={styles.cell} key={columnIndex}>
              <TableStatusPageDataCellLoading />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export const TableStatusPageDataPanelLoading = () => {
  return (
    <Panel size={'full'} active scrollable>
      <Column className={styles.tablePanelColumn}>
        <ColumnCell max>
          <TableStatusPageDataLoading />
        </ColumnCell>
      </Column>
    </Panel>
  );
};

export const TableStatusPageLoading = () => {
  return (
    <PageLayoutColumns shiftForHeader>
      <Panels>
        <Panel size={'full'} active>
          <Column className={styles.loading}>
            <ColumnCell className={styles.toolbar}>
              <div className={styles.toolbarSelectors}>
                <div className={styles.toolbarSelector}>
                  <GreyBoxLoader className={styles.cropSelectorLabel} />
                  <span className={styles.toolbarSelectorChevron} />
                </div>
                <div className={styles.toolbarSelector}>
                  <GreyBoxLoader className={styles.toolbarSelectorLabel} />
                  <span className={styles.toolbarSelectorChevron} />
                </div>
              </div>
              <div className={styles.toolbarActions}>
                <GreyBoxLoader className={styles.toolbarAction} />
                <GreyBoxLoader className={styles.toolbarAction} />
                <GreyBoxLoader className={styles.toolbarActionIcon} />
              </div>
            </ColumnCell>

            <ColumnCell max>
              <TableStatusPageDataLoading />
            </ColumnCell>
          </Column>
        </Panel>
      </Panels>
    </PageLayoutColumns>
  );
};
